import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const TableStyles = ({ theme, leftColumnAlignment }) => {
  const table = theme?.components?.Table
  const { header, row, radius } = table || {}

  const stroke = {
    width: table?.stroke?.width ?? '1px',
    style: table?.stroke?.style ?? `solid ${theme?.colors?.light?.base?.hex}`,
  }

  const headerTopStroke = header?.stroke?.top ?? 'none'

  const headerBottomStroke =
    header?.stroke?.bottom ?? `2px solid ${theme.colors.secondary.base.hex}`

  const headerHasBottomStroke = // stroke by default
    !header?.stroke?.bottom ||
    header?.stroke?.bottom === 'none' ||
    header?.stroke?.bottom !== '0'

  return css`
    width: 100%;
    white-space: nowrap;
    overflow: auto;

    table {
      border: ${stroke?.width} ${stroke?.style};
      border-radius: ${radius || '0px'};
      font-size: ${theme.fonts.body.md.size}px;
      font-weight: ${theme.fonts.body.md.weight};
      font-family: inherit;
      border-spacing: 0;
      border-spacing: 0;
      width: 100%;

      a:visited {
        color: ${theme.colors.secondary.dark.hex};
      }
    }

    tr > th {
      border-top: ${headerTopStroke};
      border-bottom: ${headerBottomStroke};
      font-weight: inherit;
      color: ${header?.color || theme.colors.dark.base.hex};
    }

    tr > td {
      color: ${row?.color || theme.colors.dark.base.hex};
    }

    th,
    td {
      padding: ${theme.spacing.sm};
      min-width: 125px;
      background-color: white;
      color: ${theme.colors.dark.base.hex};
      border: 0;
      text-align: center;
      justify-content: center;

      &:first-of-type {
        *:not(button) {
          text-align: ${leftColumnAlignment ?? 'left !important'};
          justify-content: ${leftColumnAlignment === 'center'
            ? 'center'
            : 'flex-start'};
        }
      }
    }

    td {
      // We need to turn off border radius on the second tr if the header has a bottom border
      border-bottom: ${row?.stroke?.bottom ??
      `1px solid ${theme.colors.light.base.hex}`};
      white-space: pre-wrap;
    }

    tr {
      &:nth-of-type(even) {
        td {
          background-color: ${theme?.components?.Table?.alternateBgColor
            ? theme.colors.light.base.hex
            : 'white'};

          &:first-of-type {
            border-top-left-radius: ${row?.radius ?? '0'};
            border-bottom-left-radius: ${row?.radius ?? '0'};
          }

          &:last-of-type {
            border-top-right-radius: ${row?.radius ?? '0'};
            border-bottom-right-radius: ${row?.radius ?? '0'};
          }
        }
      }

      // If the header has a bottom stroke, remove the top radius on the first row

      &:nth-of-type(2) {
        td:first-of-type {
          border-top-left-radius: ${headerHasBottomStroke ? '0' : row?.radius};
        }

        td:last-of-type {
          border-top-right-radius: ${headerHasBottomStroke ? '0' : row?.radius};
        }
      }
    }

    .leshen-link-button-wrapper {
      display: block;

      .leshen-link-button,
      .leshen-phone-cta {
        display: block;
        width: 100%;
      }
    }
  `
}

export const TableWrapper = styled.div(TableStyles)

export const Dropdowns = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;

  > * {
    max-width: calc(50% - 16px) !important;
    min-width: calc(50% - 16px) !important;
    width: calc(50% - 16px) !important;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > div {
    min-width: 100%;
  }
`

export const ErrorStyles = ({ theme, showError }) => css`
  color: ${theme.colors.error.base.hex};
  visibility: ${showError ? 'unset' : 'hidden'};
`
export const ErrorWrapper = styled.div(ErrorStyles)
